<template>
	<div class="pingzheng">
        <main>
            <span>起止日期： </span>
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <el-button style="margin-left:20px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>

        </main>
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    width="160"
                    prop="create_time"
                    label="提交时间">
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p>机构持股</p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="name"
                    width="100"
                    label="持股主体全称">
                </el-table-column>

                <el-table-column
                    prop="id_number"
                    width="100"
                    label="持股主体号码">
                </el-table-column>

                <el-table-column 
                    prop="stock_number"
                    width="100"
                    label="账户">
                </el-table-column>

                <el-table-column
                    width='200'
                    prop="manager"
                    label="负责人/基金经理">
                </el-table-column>

                <el-table-column
                    width='100'
                    prop="message"
                    label="个人信息">
                </el-table-column>

                <el-table-column
                    width="400"
                    label="照片">
                    <template slot-scope="scope">
                        <span v-for="(item,i) in (scope.row.url).split(',')">
                            <el-popover
                                placement="bottom"
                                trigger="click">
                                <img :src="item" alt="" style="width:500px;height:500px" v-if="item">
                                <img :src="item" alt="" style="width:100px;height:100px;margin-right:20px" slot="reference"  v-if="item">
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="tell"
                    label="手机">
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

        </el-card>    

    </div>
</template>

<script>
    import { url } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                tableData: [],
                time:[],

                id:'',
                
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getList()
        },
		methods: {
           
            search() {
                this.current_page = 1
                this.getList()
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },
            
            getList() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url+'xs/gdSearch1', {
                    params:{
                        time1:time1,
                        time2:time2,
                        page:this.current_page,
                        per_page:this.per_page,
                    }
                }).then(res=> {
                    loading.close();
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },

           
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .pingzheng {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .pingzheng .el-input {
        width:140px;
        margin-right: 20px;
    }
 
    .pingzheng .el-select {
        width:140px;
        margin-right: 20px;
    }
    .pingzheng main {
        margin-bottom: 20px;
    }
    .pingzheng .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>

